function Attribution() {
   return (
      <footer>
         <small>Share your Qr code with your friends !</small>
      </footer>
   );
}

export default Attribution;
